import {IDefaultVOption} from "../../../interfaces/vSelectInterfaces";

export enum FormApplicationStatusType {
  draft = 0,
  inReview = 1,
  completed = 2,
  accepted = 3,
  rejected = 4
}

export const FormApplicationStatusName = {
  [FormApplicationStatusType.draft]: 'Draft',
  [FormApplicationStatusType.inReview]: 'In Review',
  [FormApplicationStatusType.completed]: 'Completed',
  [FormApplicationStatusType.accepted]: 'Accepted',
  [FormApplicationStatusType.rejected]: 'Rejected'
};

export const applicationStatusVSelectOptions: IDefaultVOption<FormApplicationStatusType>[] = [
  {label: 'Draft', value: FormApplicationStatusType.draft},
  {label: 'In Review', value: FormApplicationStatusType.inReview},
  {label: 'Completed', value: FormApplicationStatusType.completed},
  {label: 'Accepted', value: FormApplicationStatusType.accepted},
  {label: 'Rejected', value: FormApplicationStatusType.rejected}
];
